import { http, unwrapData } from '@noor/api';
import { env } from '@noor/config';
import * as z from 'zod';
import { PERMISSION_KEYS } from '../model/catalog';
import type { GrantedPermissions } from '../model/schema';

const options = { baseURL: env.VITE_CORE_API_URL };
const MY_FEATURES_PATH = '/api/v1/admin/me/features';

/** `{ features: { <key>: allowed } }` — a key missing from the map was never registered. */
const myFeaturesSchema = z.object({
  features: z.record(z.string(), z.boolean()).nullish(),
});

/**
 * The staff member's UI features: the gateway answers, per feature key,
 * whether it lets them call every endpoint of the feature. A feature is
 * hidden only when the map says `false`; a catalog key the backend never
 * registered is absent from the map and stays enabled. The gateway still
 * enforces every request.
 */
async function fetchMine(): Promise<GrantedPermissions> {
  const raw = await http.get<unknown>(MY_FEATURES_PATH, options);
  const features = myFeaturesSchema.parse(unwrapData(raw)).features ?? {};
  const keys = new Set<string>([...PERMISSION_KEYS, ...Object.keys(features)]);
  return { permissions: [...keys].filter((key) => features[key] !== false) };
}

export const accessApi = {
  /** The current user's granted UI permission keys. */
  mine: fetchMine,
};
